/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipo di nodo dell\'albero di eleggibilita\' (gruppo combinatore o predicato foglia)
 */
export enum TipoNodoEleggibilita {

    GRUPPO = 'GRUPPO',

    PREDICATO = 'PREDICATO'
}

